import React from "react";
import { useRecoilValue } from "recoil";
import { permissionsSelector } from "../../../Login/selectors/permissionSelector";
import { PERMISSIONS } from "../../../PermissionsConstants";
import WarrantyCoverageTable from "./view/WarrantyCoverageTable";

interface WarrantyCoverageProps {}
export const WarrantyCoverage: React.FC<WarrantyCoverageProps> = () => {
  const viewPermission =
    PERMISSIONS.permission_utilities_securityconfiguration_warrantycoverage_view;
  const userPermissions = useRecoilValue(permissionsSelector);
  return (
    <>
      {" "}
      {userPermissions.includes(viewPermission) && (
        <WarrantyCoverageTable />
      )}{" "}
    </>
  );
};
export default WarrantyCoverage;
